import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { ACTION_BUTTON_CLASSES } from './actionButtonClasses'
import _ButtonStyles from 'templates/Button/_ButtonStyles'
import icon_close from './_images/icon_close.svg'
import icon_download from './_images/icon_download.png'
import icon_file from './_images/icon_file.png'


export default class Button extends Component {
  render () {
    const {
      props: {
        submit,
        reset,
        formNoValidate,
        style,
        className,
        small,
        text,
        link,
        dotted,
        without_border,
        icon_url,
      }
    } = this

    return (
      <_ButtonStyles
        type={(submit || formNoValidate)
              ? 'submit'
              : reset ? 'reset'
                      : 'button'}
        {...(style ? {css: style} : {})}
        {...this.props}
        className={[className, !small && !text && !link && !dotted && !without_border && !icon_url && ACTION_BUTTON_CLASSES].filter(Boolean).join(' ')}
      />)
  }

  static IconClose = (props) => <Button icon_size="12px" icon_url={icon_close} without_border {...props} />

  static IconDownload = (props) => <Button icon_size="16px" icon_url={icon_download} without_border {...props} />

  static IconFile = (props) => <Button icon_size="16px" icon_url={icon_file} without_border {...props} />

  static propTypes = {
    children: PropTypes.node,
    formNoValidate: PropTypes.bool,

    success: PropTypes.bool,
    primary: PropTypes.bool,
    accent: PropTypes.bool,
    text: PropTypes.bool,
    link: PropTypes.bool,
    danger: PropTypes.bool,
    dotted: PropTypes.bool,
    info: PropTypes.bool,

    light: PropTypes.bool,
    block: PropTypes.bool,

    /**
     * Растягивать во всю ширину родителя
     */
    stretch: PropTypes.bool,

    small: PropTypes.bool,
    submit: PropTypes.bool,
    without_border: PropTypes.bool,
    reset: PropTypes.bool,
    disabled: PropTypes.bool,
    to: PropTypes.oneOfType(
      [
        PropTypes.object,
        PropTypes.string
      ]
    ),
    href: PropTypes.string,
    onClick: PropTypes.func,
    css: PropTypes.oneOfType(
      [
        PropTypes.array,
        PropTypes.string
      ]
    )
  }
}

